import { memo } from 'react';
import { Alert, Box, Card, Text } from '@zillow/constellation-10';
import type { YourRentalErrorDto } from '@zg-rentals/ts-your-rental-api-client';

type ErrorCardProps = {
  icon: React.ReactNode;
  title: string;
  error: YourRentalErrorDto;
  dataTestId: string;
};

const ErrorCard = memo(({ icon, title, error, dataTestId }: ErrorCardProps) => {
  return (
    <Card
      elevated={false}
      data-testid={`DocumentCard-${dataTestId}-Error`}
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '{spacing.default} {spacing.loose} {spacing.loose}',
        flex: 1,
        height: '100%',
      }}
    >
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          gap: 'tighter',
          paddingBottom: 'default',
          borderBottom: '{borderWidths.default} solid {colors.gray.300}',
          width: '100%',
        }}
      >
        {icon}
        <Text textStyle="heading-xs">{title}</Text>
      </Box>
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '{spacing.default} 0',
          flex: '1 1 auto',
          width: '100%',
        }}
      >
        <Alert tone="critical" css={{ width: '100%' }}>
          {error.message}
        </Alert>
      </Box>
    </Card>
  );
});

ErrorCard.displayName = 'ErrorCard';

export default ErrorCard;
